<template>
  <b-overlay
      :show="overlay"
      rounded="sm"
  >
    <div
        v-if="products !== null"
        class="product-page"
    >
      <section id="ecommerce-header">
        <div class="row">
          <div class="col-sm-12">
            <div class="ecommerce-header-items">
              <div class="result-toggler">
                <feather-icon
                    icon="MenuIcon"
                    class="d-block d-lg-none"
                    size="21"
                    @click="mqShallShowLeftSidebar = true"
                />

                <div class="search-results">
                  {{ totalCount }} محصول یافت شد
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <div class="body-content-overlay" />

      <div class="ecommerce-searchbar mt-1">
        <b-row>
          <b-col
              md="10"
              cols="12"
          >
            <b-input-group class="input-group-merge">
              <b-form-input
                  v-model.trim="searchQuery"
                  placeholder="جستجوی محصولات"
                  class="search-product"
                  @keyup.enter="submitSearch"
              />

              <b-input-group-append is-text>
                <feather-icon
                    icon="SearchIcon"
                    class="text-muted"
                />
              </b-input-group-append>
            </b-input-group>
          </b-col>

          <b-col
              cols="12"
              md="2"
              class="d-flex align-items-center justify-content-start mt-1 mt-md-0"
          >
            <b-button
                variant="success"
                :block="
                                $store.getters[
                                    'app/currentBreakPoint'
                                ] === 'xs'
                            "
                @click="downloadFile"
            >
              دانلود اکسل لیست
            </b-button>
          </b-col>

          <b-col cols="12">
            <div class="product-categories mt-2">
                            <span class="filter-title">
                                نمایش محصولات باندل
                            </span>

              <b-form-checkbox
                  v-model="
                                    defaultGetProductData.showOnlyInBundle
                                "
                  name="show-only-in-bundle"
                  switch
                  inline
              />
            </div>
          </b-col>
        </b-row>
      </div>

      <section :class="itemView">
        <b-card
            v-for="product in products"
            :key="product.productId"
            class="ecommerce-card"
            no-body
        >
          <div class="item-img text-center pt-0">
            <b-link
                class="w-100 position-relative"
                :to="{
                                name: 'apps-e-commerce-product-details',
                                params: {
                                    id: product.productId,
                                },
                            }"
            >
              <b-img
                  fluid
                  class="card-img-top product-image"
                  :src="getProductImage(product)"
                  :alt="product.title || 'تصویر محصول'"
              />

              <b-badge
                  v-if="hasProductMedia(product)"
                  class="product-badge p-1"
                  variant="light-primary"
              >
                دارای مدیا
              </b-badge>
            </b-link>
          </div>

          <b-card-body>
            <div class="item-wrapper">
              <h6 class="item-name">
                <b-link
                    class="text-body"
                    :to="{
                                        name:
                                            'apps-e-commerce-product-details',
                                        params: {
                                            id: product.productId,
                                        },
                                    }"
                >
                  {{ product.title }}
                </b-link>
              </h6>

              <div>
                <h6
                    v-if="!product.isFree"
                    class="item-price text-info"
                >
                  {{
                    makePrettyPrice(
                        product.price
                    )
                  }}
                  تومان
                </h6>

                <h6
                    v-else
                    class="item-price text-success"
                >
                  رایگان
                </h6>
              </div>
            </div>

            <b-card-text
                v-if="product.description"
                class="item-description"
                v-html="product.description"
            />

            <b-card-text
                v-else
                class="item-description text-muted"
            >
              توضیحی برای این محصول ثبت نشده است.
            </b-card-text>

            <div class="d-flex flex-wrap align-items-center">
              <b-badge
                  variant="warning"
                  class="d-inline-block"
              >
                {{ getProductTypeTitle(product.type) }}
              </b-badge>

              <b-badge
                  class="ml-1"
                  variant="info"
              >
                <feather-icon
                    icon="EyeIcon"
                    class="mr-25"
                />

                <span>
                                    {{ product.viewCounts || 0 }}
                                </span>
              </b-badge>
            </div>
          </b-card-body>

          <div class="item-options text-center">
            <div
                v-if="!product.isFree"
                class="item-wrapper"
            >
              <div class="item-cost">
                <h4 class="item-price">
                  {{
                    makePrettyPrice(
                        product.price
                    )
                  }}
                  تومان
                </h4>
              </div>
            </div>

            <div
                v-else
                class="item-wrapper"
            >
              <div class="item-cost">
                <h4 class="item-price text-success">
                  رایگان
                </h4>
              </div>
            </div>

            <b-button
                variant="danger"
                tag="a"
                class="btn-wishlist"
                v-b-modal.modal-delete
                @click="showModal(product.productId)"
            >
              <feather-icon
                  icon="TrashIcon"
                  class="mr-50"
              />

              <span>حذف</span>
            </b-button>

            <b-button
                variant="light"
                tag="a"
                class="btn-cart"
                @click.prevent="goToEditProduct(product)"
            >
              <feather-icon
                  icon="EditIcon"
                  class="mr-50"
              />

              <span>ویرایش</span>
            </b-button>

            <b-button
                v-if="
                                product.type !== 6 &&
                                product.type !== 7
                            "
                variant="info"
                tag="a"
                class="btn-cart"
                @click.prevent="goToUploadMediaUrl(product)"
            >
              <feather-icon
                  icon="CastIcon"
                  class="mr-50"
              />

              <span>مدیا</span>
            </b-button>

            <b-button
                v-if="product.type === 1 || product.type===3"
                variant="primary"
                tag="a"
                class="btn-cart"
                @click.prevent="goToTopics(product)"
            >
              <feather-icon
                  icon="ListIcon"
                  class="mr-50"
              />

              <span>ایجاد سرفصل‌ها</span>
            </b-button>

            <b-button
                v-if="product.type === 8"
                variant="success"
                tag="a"
                class="btn-cart"
                @click.prevent="goToQuestions(product)"
            >
              <feather-icon
                  icon="HelpCircleIcon"
                  class="mr-50"
              />

              <span>لیست سوالات</span>
            </b-button>

            <b-button
                v-if="product.type === 6"
                variant="info"
                tag="a"
                class="btn-cart"
                @click.prevent="
                                goToPackageProducts(product)
                            "
            >
              <feather-icon
                  icon="ArchiveIcon"
                  class="mr-50"
              />

              <span>محصولات</span>
            </b-button>

            <b-button
                v-if="product.type === 7"
                variant="info"
                tag="a"
                class="btn-cart"
                @click.prevent="
                                goToBundleProducts(product)
                            "
            >
              <feather-icon
                  icon="ArchiveIcon"
                  class="mr-50"
              />

              <span>محصولات</span>
            </b-button>

            <b-button
                variant="success"
                tag="a"
                class="btn-wishlist"
                @click.prevent="
                                goToProductComments(product)
                            "
            >
              <feather-icon
                  icon="MessageSquareIcon"
                  class="mr-50"
              />

              <span>لیست نظرات</span>
            </b-button>

            <b-button
                variant="warning"
                tag="a"
                class="btn-wishlist"
                @click.prevent="
                                goToAddProductComments(product)
                            "
            >
              <feather-icon
                  icon="UploadIcon"
                  class="mr-50"
              />

              <span>ارسال اکسل نظرات</span>
            </b-button>
          </div>
        </b-card>
      </section>

      <section>
        <b-row>
          <b-col cols="12">
            <QueriedPagination
                v-if="totalCount"
                v-model="currentPage"
                :total-counts="totalCount"
                :per-page="
                                defaultGetProductData.count
                            "
            />
          </b-col>
        </b-row>
      </section>

      <portal to="content-renderer-sidebar-detached-left">
        <shop-left-filter-sidebar
            :filters="filters"
            :filter-options="filterOptions"
            :categories="productCategories"
            :mq-shall-show-left-sidebar.sync="
                        mqShallShowLeftSidebar
                    "
            :types="types"
            :show-only-in-bundle="
                        defaultGetProductData.showOnlyInBundle
                    "
            @changeCategory="changeCategory"
            @changeType="changeType"
        />
      </portal>
    </div>

    <b-modal
        id="modal-delete"
        centered
        ok-title="حذف"
        cancel-title="انصراف"
        @ok="deleteProduct(deleteItem)"
    >
      <span>این محصول حذف شود؟</span>
    </b-modal>
  </b-overlay>
</template>

<script>
import {
  BBadge,
  BButton,
  BCard,
  BCardBody,
  BCardText,
  BCol,
  BFormCheckbox,
  BFormInput,
  BImg,
  BInputGroup,
  BInputGroupAppend,
  BLink,
  BModal,
  BOverlay,
  BRow,
} from "bootstrap-vue";

import Ripple from "vue-ripple-directive";
import { watch } from "@vue/composition-api";
import {
  useResponsiveAppLeftSidebarVisibility,
} from "@core/comp-functions/ui/app";

import ShopLeftFilterSidebar from "./ECommerceShopLeftFilterSidebar.vue";

import {
  useShopFiltersSortingAndPagination,
  useShopUi,
} from "./useECommerceShop";

import {
  ProductCategoryGetAllProductCategoriesRequest,
  ProductDeleteProductRequest,
  ProductGetAllRequest,
} from "@/libs/Api/Product";

import ToastificationContent from "@core/components/toastification/ToastificationContent";
import Helper from "@/libs/Helper";
import axiosIns from "@/libs/axios";
import { saveAs } from "file-saver";
import QueriedPagination from "@/views/components/QueriedPagination.vue";

export default {
  title: "لیست محصولات - پنل ادمین بنفشه باقری",

  components: {
    QueriedPagination,
    BFormCheckbox,
    BRow,
    BCol,
    BInputGroup,
    BInputGroupAppend,
    BFormInput,
    BCard,
    BCardBody,
    BLink,
    BImg,
    BCardText,
    BButton,
    BOverlay,
    BBadge,
    BModal,
    ShopLeftFilterSidebar,
  },

  directives: {
    Ripple,
  },

  data() {
    return {
      products: null,
      overlay: false,
      baseUrl: Helper.baseUrl,
      totalCount: 0,
      productCategories: [],
      deleteItem: null,
      currentPage: 1,
      searchQuery: "",
      searchTimer: null,

      types: [
        {
          label: "دوره‌ها",
          value: 1,
        },
        {
          label: "کتاب‌ها",
          value: 3,
        },
      ],

      defaultGetProductData: {
        categoryId: 0,
        searchByTitle: "",
        pageNumber: 1,
        count: 9,
        type: 1,
        showOnlyInBundle: false,
      },
    };
  },

  computed: {
    getQuery() {
      return this.$route.query;
    },
  },

  watch: {
    getQuery: {
      deep: true,

      handler() {
        const pageNumber = Number(
            this.$route.query.pageNumber
        );

        if (
            pageNumber > 0 &&
            pageNumber !== this.currentPage
        ) {
          this.currentPage = pageNumber;
        }

        this.defaultGetProductData.pageNumber =
            this.currentPage;

        this.getProducts();
      },
    },

    searchQuery(value) {
      clearTimeout(this.searchTimer);

      this.searchTimer = setTimeout(() => {
        this.defaultGetProductData.searchByTitle =
            String(value || "").trim();

        this.currentPage = 1;
        this.defaultGetProductData.pageNumber = 1;

        this.getProducts();
      }, 500);
    },

    currentPage(value) {
      const pageNumber = Number(value) || 1;

      if (
          this.defaultGetProductData.pageNumber ===
          pageNumber
      ) {
        return;
      }

      this.defaultGetProductData.pageNumber =
          pageNumber;

      this.getProducts();
    },

    "defaultGetProductData.categoryId"() {
      this.resetPageAndFetch();
    },

    "defaultGetProductData.type"() {
      this.resetPageAndFetch();
    },

    "defaultGetProductData.showOnlyInBundle"() {
      this.resetPageAndFetch();
    },
  },

  async created() {
    const pageNumber = Number(
        this.$route.query.pageNumber
    );

    if (pageNumber > 0) {
      this.currentPage = pageNumber;

      this.defaultGetProductData.pageNumber =
          pageNumber;
    }

    await Promise.all([
      this.getProducts(),
      this.getCategories(),
    ]);
  },

  beforeDestroy() {
    clearTimeout(this.searchTimer);
  },

  methods: {
    async getProducts() {
      this.overlay = true;

      const request =
          new ProductGetAllRequest(this);

      request.setParams({
        categoryId:
        this.defaultGetProductData.categoryId,

        searchByTitle:
        this.defaultGetProductData.searchByTitle,

        pageNumber:
        this.defaultGetProductData.pageNumber,

        count:
        this.defaultGetProductData.count,

        type:
        this.defaultGetProductData.type,

        isFree: "",

        showOnlyInBundle:
        this.defaultGetProductData.showOnlyInBundle,
      });

      try {
        await request.fetch(
            (content) => {
              this.products =
                  content &&
                  Array.isArray(content.products)
                      ? content.products
                      : [];

              this.totalCount =
                  Number(
                      content &&
                      content.productsCount
                  ) || 0;
            },

            (error) => {
              console.error(
                  "Get products error:",
                  error
              );

              this.products = [];
              this.totalCount = 0;

              this.showErrorToast(
                  "دریافت محصولات با خطا مواجه شد."
              );
            }
        );
      } catch (error) {
        console.error(
            "Unexpected get products error:",
            error
        );

        this.products = [];
        this.totalCount = 0;

        this.showErrorToast(
            "دریافت محصولات با خطا مواجه شد."
        );
      } finally {
        this.overlay = false;
      }
    },

    async getCategories() {
      this.overlay = true;

      const request =
          new ProductCategoryGetAllProductCategoriesRequest(
              this
          );

      request.setParams({
        pageNumber: 0,
        count: 0,
      });

      try {
        await request.fetch(
            (content) => {
              this.productCategories =
                  content &&
                  Array.isArray(
                      content.productCategories
                  )
                      ? content.productCategories
                      : [];
            },

            (error) => {
              console.error(
                  "Get categories error:",
                  error
              );

              this.productCategories = [];
            }
        );
      } catch (error) {
        console.error(
            "Unexpected get categories error:",
            error
        );

        this.productCategories = [];
      } finally {
        this.overlay = false;
      }
    },

    async deleteProduct(productId) {
      const id = Number(productId);

      if (!id) {
        this.showErrorToast(
            "شناسه محصول معتبر نیست."
        );

        return;
      }

      this.overlay = true;

      const request =
          new ProductDeleteProductRequest(this);

      request.setId(id);

      try {
        await request.fetch(
            async () => {
              this.showSuccessToast(
                  "محصول حذف شد."
              );

              this.deleteItem = null;

              await this.getProducts();
            },

            (error) => {
              console.error(
                  "Delete product error:",
                  error
              );

              this.showErrorToast(
                  this.getErrorMessage(
                      error,
                      "حذف محصول انجام نشد."
                  )
              );
            }
        );
      } catch (error) {
        console.error(
            "Unexpected delete product error:",
            error
        );

        this.showErrorToast(
            "حذف محصول انجام نشد."
        );
      } finally {
        this.overlay = false;
      }
    },

    submitSearch() {
      clearTimeout(this.searchTimer);

      this.defaultGetProductData.searchByTitle =
          String(this.searchQuery || "").trim();

      this.resetPageAndFetch();
    },

    resetPageAndFetch() {
      this.currentPage = 1;

      this.defaultGetProductData.pageNumber = 1;

      this.getProducts();
    },

    changeCategory(categoryId) {
      this.defaultGetProductData.categoryId =
          Number(categoryId) || 0;
    },

    changeType(type) {
      this.defaultGetProductData.type =
          Number(type) || 1;
    },

    makePrettyPrice(price) {
      return Helper.prettyPrice(
          Number(price) || 0,
          0
      );
    },

    showModal(productId) {
      this.deleteItem =
          Number(productId) || null;
    },

    getProductImage(product) {
      if (
          !product ||
          !product.imageFile
      ) {
        return "/logo.png";
      }

      const imageFile =
          String(product.imageFile);

      if (
          imageFile.startsWith("http://") ||
          imageFile.startsWith("https://")
      ) {
        return imageFile;
      }

      return `${this.baseUrl}${imageFile}`;
    },

    hasProductMedia(product) {
      return Boolean(
          product &&
          product.fileData !== null &&
          product.fileData !== undefined &&
          product.fileData !== ""
      );
    },

    getProductTypeTitle(type) {
      const normalizedType = Number(type);

      const titles = {
        1: "دوره",
        2: "فیلم",
        3: "فایل",
        4: "پادکست",
        6: "پکیج",
        7: "باندل",
        8: "آزمون",
      };

      return titles[normalizedType] || "محصول";
    },

    goToEditProduct(product) {
      this.$router.push({
        name:
            "apps-e-commerce-product-details",

        params: {
          id: product.productId,
        },
      });
    },

    goToTopics(product) {
      const productId = Number(
          product && product.productId
      );

      if (!productId) {
        this.showErrorToast(
            "شناسه محصول معتبر نیست."
        );

        return;
      }

      this.$router.push({
        name: "apps-e-commerce-add-product-Topics",
        params: {
          id: productId,
        },
      });
    },

    goToUploadMediaUrl(product) {
      if (
          product.type === 8 &&
          product.psychologicalTestType === 4
      ) {
        this.$router.push({
          name:
              "apps-e-commerce-AddMediaToTest",

          params: {
            id: product.productId,
          },

          query: {
            productType:
            product.type,
          },
        });

        return;
      }

      this.$router.push({
        name:
            "apps-e-commerce-add-product-media-with-chunk",

        params: {
          id: product.productId,
        },

        query: {
          productType:
          product.type,
        },
      });
    },

    goToQuestions(product) {
      this.$router.push({
        name: "apps-question-title",

        params: {
          title:
          product.title,

          id:
          product.psychologicalTestId,
        },
      });
    },

    goToPackageProducts(product) {
      this.$router.push({
        name:
            "apps-e-commerce-packages-list-id",

        params: {
          id: product.productId,
        },
      });
    },

    goToBundleProducts(product) {
      this.$router.push({
        name:
            "apps-package-list-id",

        params: {
          id: product.bundleId,
        },
      });
    },

    goToProductComments(product) {
      this.$router.push({
        name:
            "apps-e-commerce-ProductCommentById",

        params: {
          id: product.productId,
        },
      });
    },

    goToAddProductComments(product) {
      this.$router.push({
        name:
            "apps-e-commerce-add-product-comment",

        params: {
          id: product.productId,
        },
      });
    },

    async downloadFile() {
      this.$store.commit(
          "app/TOGGLE_DOWNLOAD"
      );

      try {
        const response =
            await axiosIns.post(
                "Product/GenerateProductExcel",
                null,
                {
                  responseType: "blob",
                }
            );

        saveAs(
            response.data,
            "لیست محصولات.xlsx"
        );
      } catch (error) {
        console.error(
            "Download product Excel error:",
            error
        );

        this.showErrorToast(
            "به علت ترافیک بالا، لطفاً ۳۰ دقیقه دیگر امتحان کنید."
        );
      } finally {
        this.$store.commit(
            "app/TOGGLE_DOWNLOAD"
        );
      }
    },

    getErrorMessage(error, fallback) {
      return (
          error &&
          error.response &&
          error.response.data &&
          error.response.data.message
      ) || fallback;
    },

    showSuccessToast(message) {
      this.$toast({
        component:
        ToastificationContent,

        position: "bottom-center",

        props: {
          title: "عملیات موفق",
          icon: "CheckIcon",
          variant: "success",
          text: message,
        },
      });
    },

    showErrorToast(message) {
      this.$toast({
        component:
        ToastificationContent,

        position: "bottom-center",

        props: {
          title: "عملیات ناموفق",
          icon: "AlertCircleIcon",
          variant: "danger",
          text: message,
        },
      });
    },
  },

  setup() {
    const {
      filters,
      filterOptions,
      sortBy,
    } =
        useShopFiltersSortingAndPagination();

    const {
      itemView,
    } = useShopUi();

    const {
      mqShallShowLeftSidebar,
    } =
        useResponsiveAppLeftSidebarVisibility();

    watch(
        [filters, sortBy],
        () => {},
        {
          deep: true,
        }
    );

    return {
      filters,
      filterOptions,
      sortBy,
      itemView,
      mqShallShowLeftSidebar,
    };
  },
};
</script>

<style lang="scss">
@import "~@core/scss/base/pages/app-ecommerce.scss";
</style>

<style lang="scss" scoped>
.item-view-radio-group::v-deep {
  .btn {
    display: flex;
    align-items: center;
  }
}

.product-page {
  min-height: inherit;
}

.product-image {
  width: 100%;
  height: 25rem !important;
  object-fit: contain;
}

.item-options {
  .btn {
    min-height: 42px;
  }
}
</style>